import { SectionTitle } from "@/components/shared/SectionTitle";

const ITEMS = [
  {
    problem: "看不到真房",
    answer: "管家视频实地看房,房间每个角落都拍给你看",
    tint: "coral" as const,
  },
  {
    problem: "不理解新加坡住房规则",
    answer: "HDB/Condo政策、押金、租期、违约——我们用中文讲清楚",
    tint: "gold" as const,
  },
  {
    problem: "怕被二房东骗",
    answer: "我们逐套验证房源真实性,只推持牌中介房源",
    tint: "forest" as const,
  },
  {
    problem: "落地手忙脚乱",
    answer: "从落地新加坡开始——手机卡、银行卡、买家具,全程指导",
    tint: "coral2" as const,
  },
];

const TINT = {
  coral: "bg-coral-50 text-coral-700",
  gold: "bg-gold-100 text-gold-700",
  forest: "bg-forest-50 text-forest-700",
  coral2: "bg-coral-100 text-coral-900",
};

export function Problems() {
  return (
    <section className="px-5 pb-5 pt-8">
      <SectionTitle>
        留学租房上
        <br />
        最容易踩的四个坑。
      </SectionTitle>
      <ul className="flex flex-col gap-2.5">
        {ITEMS.map((it) => (
          <li
            key={it.problem}
            className="overflow-hidden rounded-[22px] border border-[var(--line-soft)] bg-paper p-[18px] shadow-card"
          >
            <div className="mb-2 flex items-center gap-3">
              <div
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-[10px] ${TINT[it.tint]}`}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
                  <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.4" />
                  <path
                    d="M8 4.5v4M8 11v0.5"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <p className="min-w-0 flex-1 text-[15.5px] font-semibold tracking-tight text-ink-900">
                {it.problem}
              </p>
            </div>
            <p className="text-flow pl-11 text-[13.5px] leading-[1.7] text-ink-600">{it.answer}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
